<mat-card style="text-align: center;">

    <img src="./assets/img/logoSofipa.png" width="50%">

    <mat-card-content>

        <form #loginForm="ngForm">
            <div class="form-group">

            </div>
            <div class='row'>

                <div class='column first-col'>
                    <mat-icon matSuffix style="padding-top: 100%;font-size: 200%; ">person</mat-icon>
                </div>
                <div class='column justify-content-center'>
                    <mat-form-field class="example-form-field" appearance="fill">

                        <mat-label>Usuario</mat-label>
                        <input matInput type="text" [(ngModel)]="usuario.username" name="username" class="form-control"
                            oninput="this.value = this.value.toUpperCase()" required
                            [ngClass]="{ 'is-invalid': (username.touched || username.dirty) && username.errors }"
                            #username="ngModel" />

                        <mat-error *ngIf="username.errors">
                            El usuario es requerido
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class='row'>
                <div class='column first-col'>
                    <mat-icon matSuffix style="padding-top: 100%;font-size: 150%;">https</mat-icon>
                </div>
                <div class='column justify-content-center'>
                    <mat-form-field class="example-form-field" appearance="fill">
                        <mat-label>Contraseña</mat-label>
                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <input matInput type="password" [(ngModel)]="usuario.password" name="password"
                            [type]="hide ? 'password' : 'text'" class="form-control" required
                            [ngClass]="{ 'is-invalid': (password.touched || password.dirty) && password.errors }"
                            #password="ngModel" />
                        <mat-error *ngIf="password.errors">
                            La contraseña es requerida
                        </mat-error>
                    </mat-form-field>

                </div>
            </div>
            <div class='row'>
                <div class='column first-col'>
                    <mat-icon matSuffix style="padding-top: 80%;font-size: 180%;">home</mat-icon>
                </div>
                <div class='column justify-content-center' *ngIf="!conexion">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>Sucursal</mat-label>
                        <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto" required
                            [(ngModel)]="sucursal">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{option.name}}
                            </mat-option>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
                <div class='column justify-content-center b' *ngIf="conexion">
                    <b>Error de comunicación con el servidor</b>
                </div>
            </div>
            <div class="form-group">
                <button mat-flat-button color="accent" [disabled]="loading||loginForm.invalid" class="btn btn-primary"
                    (click)="onSubmit()">Acceder</button>

            </div>

        </form>
    </mat-card-content>
</mat-card>